/* ================================================================
   PYRAMASON — pyra-cosmos.js (W37)
   The homepage film's cosmos, distilled for every other page:
   one lightweight persistent 3D sky (stars · painted nebulae ·
   comets · gold dust) + one signature element per page.
   window.PYRA_SCENE: 'calm' | 'wheel' | 'pyramids' | 'sigils' | 'watchers'
   Requires three.js r128 loaded first. No bloom (subpages stay light).
   ================================================================ */
(function(){
'use strict';
if(!window.THREE)return;
var reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
var SCENE=window.PYRA_SCENE||'calm';

/* canvas — replace any legacy #sky (it may hold a 2D context).
   Layering law: html carries the abyss, body goes transparent,
   the cosmos lives at z:-1 — content can never be veiled. */
var old=document.getElementById('sky');
if(old&&old.parentNode)old.parentNode.removeChild(old);
document.documentElement.style.background='#05070d';
document.body.style.background='transparent';
var cv=document.createElement('canvas');
cv.id='sky';
cv.style.cssText='position:fixed;inset:0;width:100%;height:100%;z-index:-1;pointer-events:none;opacity:.8;';
document.body.insertBefore(cv,document.body.firstChild);

var renderer=new THREE.WebGLRenderer({canvas:cv,antialias:true,alpha:true});
renderer.setPixelRatio(Math.min(devicePixelRatio,1.5));
renderer.setSize(innerWidth,innerHeight);
renderer.setClearColor(0x05070d,0); /* transparent — the page shows through, like the 2D sky did */
renderer.toneMapping=THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure=1.15;
var scene=new THREE.Scene();
scene.background=null;
scene.fog=new THREE.FogExp2(0x05070d,0.0016);
var camera=new THREE.PerspectiveCamera(58,innerWidth/innerHeight,.1,4000);
camera.position.set(0,0,90);
addEventListener('resize',function(){
  renderer.setSize(innerWidth,innerHeight);
  camera.aspect=innerWidth/innerHeight;camera.updateProjectionMatrix();
});
scene.add(new THREE.AmbientLight(0x36405e,1.1));
var key=new THREE.DirectionalLight(0xf0d78a,1.0);
key.position.set(160,120,-600);scene.add(key);

/* ---- textures ---- */
function cnv(w,h,fn){var c=document.createElement('canvas');c.width=w;c.height=h;fn(c.getContext('2d'),w,h);
  return new THREE.CanvasTexture(c);}
function dot(stops){return cnv(64,64,function(x){
  var g=x.createRadialGradient(32,32,0,32,32,32);
  stops.forEach(function(s){g.addColorStop(s[0],s[1]);});
  x.fillStyle=g;x.fillRect(0,0,64,64);});}
var texStar=dot([[0,'rgba(255,250,235,1)'],[.35,'rgba(238,231,214,.7)'],[1,'rgba(238,231,214,0)']]);
var texGold=dot([[0,'rgba(245,230,176,1)'],[.3,'rgba(232,197,71,.75)'],[1,'rgba(201,162,39,0)']]);
var texIndigo=dot([[0,'rgba(90,110,170,.55)'],[.5,'rgba(45,58,100,.28)'],[1,'rgba(20,28,54,0)']]);
function makeNoise(seed){
  var perm=[];for(var i=0;i<256;i++)perm[i]=i;
  var s=seed||7;function rnd(){s=(s*16807)%2147483647;return s/2147483647;}
  for(var j=255;j>0;j--){var k=Math.floor(rnd()*(j+1));var tv=perm[j];perm[j]=perm[k];perm[k]=tv;}
  perm=perm.concat(perm);
  function fade(t2){return t2*t2*(3-2*t2);}
  function lerp(a,b,t){return a+(b-a)*t;}
  return function(x,y){
    var X=Math.floor(x)&255,Y=Math.floor(y)&255;
    x-=Math.floor(x);y-=Math.floor(y);
    var u=fade(x),v=fade(y);
    function g(h,x2,y2){return ((h&1)?-x2:x2)+((h&2)?-y2:y2);}
    var A=perm[X]+Y,B=perm[X+1]+Y;
    return lerp(lerp(g(perm[A],x,y),g(perm[B],x-1,y),u),
                lerp(g(perm[A+1],x,y-1),g(perm[B+1],x-1,y-1),u),v)*.5+.5;
  };
}
function nebulaTex(r,g,b,seed){
  var nz=makeNoise(seed);
  var S=128; /* W38: 128px is visually identical at sprite scale, 2.4× faster */
  return cnv(S,S,function(x){
    var img=x.createImageData(S,S);
    var h=S/2;
    for(var i=0;i<S;i++)for(var j=0;j<S;j++){
      var dx=(i-h)/h,dy=(j-h)/h;
      var d=Math.sqrt(dx*dx+dy*dy);
      var v=nz(i*.039,j*.039)*.5+nz(i*.094,j*.094)*.3+nz(i*.22,j*.22)*.2;
      var a=Math.max(0,(v-.34))*1.5*Math.max(0,1-d);
      var o=(j*S+i)*4;
      img.data[o]=r;img.data[o+1]=g;img.data[o+2]=b;img.data[o+3]=Math.min(255,a*255);
    }
    x.putImageData(img,0,0);
  });
}
/* vector sigils (no emoji) */
function glyphTex(ch){return cnv(128,128,function(x){
  x.strokeStyle='#e8c547';x.fillStyle='#e8c547';
  x.lineWidth=6;x.lineCap='round';x.lineJoin='round';
  x.shadowColor='rgba(232,197,71,.9)';x.shadowBlur=16;
  var b=x.beginPath.bind(x),s=x.stroke.bind(x);
  function arc(cx,cy,r,a0,a1,ccw){x.arc(cx,cy,r,a0,a1,!!ccw);}
  function line(x1,y1,x2,y2){x.moveTo(x1,y1);x.lineTo(x2,y2);}
  switch(ch){
    case 'sun':b();arc(64,64,30,0,Math.PI*2);s();b();arc(64,64,6,0,Math.PI*2);x.fill();break;
    case 'moon':b();arc(58,64,30,-Math.PI/2,Math.PI/2);s();b();arc(72,64,30,Math.PI/2,-Math.PI/2,true);s();break;
    case 'saturn':b();line(40,40,72,40);s();b();line(56,28,56,76);s();
      b();x.moveTo(56,60);x.bezierCurveTo(70,48,88,60,80,78);x.bezierCurveTo(76,88,68,92,72,100);s();break;
    case 'jupiter':b();x.moveTo(34,72);x.bezierCurveTo(34,44,66,40,66,64);s();
      b();line(30,84,92,84);s();b();line(76,56,76,104);s();break;
    case 'venus':b();arc(64,50,24,0,Math.PI*2);s();b();line(64,74,64,106);s();b();line(48,90,80,90);s();break;
    case 'mercury':b();arc(64,58,20,0,Math.PI*2);s();b();line(64,78,64,104);s();b();line(52,92,76,92);s();
      b();arc(64,26,14,Math.PI*.15,Math.PI*.85);s();break;
    default:b();arc(64,60,24,0,Math.PI*2);s();b();line(64,22,64,104);s();break;
  }
});}

/* ---- shared cosmos ---- */
function stars(n,spread,size,tex,op){
  var g=new THREE.BufferGeometry(),pos=new Float32Array(n*3);
  for(var i=0;i<n;i++){
    pos[i*3]=(Math.random()-.5)*spread;
    pos[i*3+1]=(Math.random()-.5)*spread;
    pos[i*3+2]=(Math.random()-.5)*spread-500;
  }
  g.setAttribute('position',new THREE.BufferAttribute(pos,3));
  var p=new THREE.Points(g,new THREE.PointsMaterial({size:size,map:tex,transparent:true,opacity:op,
    depthWrite:false,blending:THREE.AdditiveBlending}));
  scene.add(p);return p;
}
var shellA=stars(2400,2400,2.4,texStar,.85);
var shellB=stars(1300,1500,1.6,texStar,.55);
var shellC=stars(650,900,3.0,texGold,.45);
/* W38: nebulae arrive a beat after first paint — stars are instant */
setTimeout(function(){
  [[nebulaTex(80,100,190,21),-520,180,-1000,620],[nebulaTex(150,110,200,33),480,-140,-900,520],
   [nebulaTex(210,170,90,47),-300,-260,-820,440],[nebulaTex(80,100,190,55),320,240,-1050,560]]
  .forEach(function(cfg){
    var s=new THREE.Sprite(new THREE.SpriteMaterial({map:cfg[0],transparent:true,opacity:.45,
      blending:THREE.AdditiveBlending,depthWrite:false}));
    s.scale.set(cfg[4],cfg[4],1);s.position.set(cfg[1],cfg[2],cfg[3]);scene.add(s);
  });
},120);
var comets=[];
for(var ci=0;ci<2;ci++){
  var head=new THREE.Sprite(new THREE.SpriteMaterial({map:texStar,transparent:true,opacity:0,
    blending:THREE.AdditiveBlending,depthWrite:false}));
  head.scale.set(7,7,1);scene.add(head);
  var tail=new THREE.Line(new THREE.BufferGeometry().setFromPoints([new THREE.Vector3(),new THREE.Vector3()]),
    new THREE.LineBasicMaterial({color:0xf5e6b0,transparent:true,opacity:0}));
  scene.add(tail);
  comets.push({head:head,tail:tail,active:false,t:0,o:null});
}

/* ---- signature elements ---- */
var sig=new THREE.Group();scene.add(sig);
var sigSpin=[];
if(SCENE==='wheel'){
  sig.position.set(0,30,-320);
  var R=150;
  var verts=[];
  for(var d=0;d<360;d++){
    var big=d%10===0,a=d*Math.PI/180,l=big?11:5;
    verts.push(Math.cos(a)*R,Math.sin(a)*R,0,Math.cos(a)*(R-l),Math.sin(a)*(R-l),0);
  }
  var g2=new THREE.BufferGeometry();
  g2.setAttribute('position',new THREE.Float32BufferAttribute(verts,3));
  var ticks=new THREE.LineSegments(g2,new THREE.LineBasicMaterial({color:0xe8c547,transparent:true,opacity:.5}));
  sig.add(ticks);sigSpin.push(ticks);
  var torus=new THREE.Mesh(new THREE.TorusGeometry(R,.7,8,120),
    new THREE.MeshBasicMaterial({color:0xc9a227,transparent:true,opacity:.55}));
  sig.add(torus);
  var glow=new THREE.Sprite(new THREE.SpriteMaterial({map:texGold,transparent:true,opacity:.16,
    blending:THREE.AdditiveBlending,depthWrite:false}));
  glow.scale.set(R*3.4,R*3.4,1);sig.add(glow);
}else if(SCENE==='pyramids'){
  sig.position.set(0,-120,-420);
  var stoneM=new THREE.MeshStandardMaterial({color:0x1a2236,roughness:.9,flatShading:true});
  [[-110,0,86,54],[70,-30,64,40]].forEach(function(cfg){
    var courses=12;
    for(var c2=0;c2<courses;c2++){
      var f0=1-c2/courses,f1=1-(c2+1)/courses;
      var course=new THREE.Mesh(new THREE.CylinderGeometry(cfg[2]*f1*.707,cfg[2]*f0*.707,cfg[3]/courses,4,1),stoneM);
      course.position.set(cfg[0],(cfg[3]/courses)*(c2+.5),cfg[1]);course.rotation.y=Math.PI/4;
      sig.add(course);
    }
    var cap=new THREE.Mesh(new THREE.ConeGeometry(cfg[2]*.707*.19,cfg[3]*.17,4,1),
      new THREE.MeshStandardMaterial({color:0xe8c547,roughness:.3,metalness:.8,emissive:0x9c7c1f,emissiveIntensity:.45}));
    cap.position.set(cfg[0],cfg[3]-cfg[3]*.08,cfg[1]);cap.rotation.y=Math.PI/4;sig.add(cap);
    var halo=new THREE.Sprite(new THREE.SpriteMaterial({map:texGold,transparent:true,opacity:.5,
      blending:THREE.AdditiveBlending,depthWrite:false}));
    halo.scale.set(20,20,1);halo.position.set(cfg[0],cfg[3]+3,cfg[1]);sig.add(halo);
  });
  var haze=new THREE.Sprite(new THREE.SpriteMaterial({map:texIndigo,transparent:true,opacity:.3,
    blending:THREE.AdditiveBlending,depthWrite:false}));
  haze.scale.set(700,160,1);haze.position.set(0,10,-40);sig.add(haze);
}else if(SCENE==='sigils'){
  sig.position.set(0,10,-300);
  ['sun','moon','saturn','jupiter','venus','mercury','phi'].forEach(function(k2,i){
    var s2=new THREE.Sprite(new THREE.SpriteMaterial({map:glyphTex(k2),transparent:true,opacity:.75,depthWrite:false}));
    s2.scale.set(26,26,1);
    s2.userData.orbit={r:130+((i%2)*40),a:i/7*Math.PI*2,v:.0012+i*.0002};
    sig.add(s2);
  });
  var ring=new THREE.Mesh(new THREE.TorusGeometry(150,.5,8,110),
    new THREE.MeshBasicMaterial({color:0xc9a227,transparent:true,opacity:.3}));
  sig.add(ring);sigSpin.push(ring);
}else if(SCENE==='watchers'){
  sig.position.set(0,-140,-460);
  var stM=new THREE.MeshStandardMaterial({color:0x18213a,roughness:.9,flatShading:true});
  for(var w2=0;w2<5;w2++){
    var h2=44+Math.sin(w2*1.9)*14;
    var st=new THREE.Mesh(new THREE.BoxGeometry(11,h2,7),stM);
    st.position.set(-190+w2*95,h2/2,(w2%2?-30:10));
    st.rotation.y=(w2-2)*.12;
    sig.add(st);
    var crown=new THREE.Sprite(new THREE.SpriteMaterial({map:texIndigo,transparent:true,opacity:.5,
      blending:THREE.AdditiveBlending,depthWrite:false}));
    crown.scale.set(26,26,1);crown.position.set(st.position.x,h2+8,st.position.z);sig.add(crown);
  }
  var moonM=new THREE.Mesh(new THREE.SphereGeometry(26,24,24),
    new THREE.MeshStandardMaterial({color:0x2a3654,roughness:.9,emissive:0x1c2740,emissiveIntensity:.6}));
  moonM.position.set(200,150,-200);sig.add(moonM);
  var mh=new THREE.Sprite(new THREE.SpriteMaterial({map:texIndigo,transparent:true,opacity:.55,
    blending:THREE.AdditiveBlending,depthWrite:false}));
  mh.scale.set(130,130,1);mh.position.copy(moonM.position);sig.add(mh);
}

/* ---- loop ---- */
var mx=0,my=0;
addEventListener('mousemove',function(e){
  mx=(e.clientX/innerWidth-.5);my=(e.clientY/innerHeight-.5);
});
var t=0;
function draw(){
  var sy=scrollY||0;
  camera.position.x=mx*6;
  camera.position.y=-my*4-Math.min(sy*.02,60);
  camera.lookAt(0,-Math.min(sy*.02,60)*.5,-600);
  shellA.rotation.y=t*.00004;shellB.rotation.y=-t*.00006;shellC.rotation.y=t*.00009;
  sigSpin.forEach(function(o){o.rotation.z=t*.0007;});
  sig.children.forEach(function(ch){
    if(ch.userData&&ch.userData.orbit){
      var o=ch.userData.orbit;o.a+=o.v;
      ch.position.set(Math.cos(o.a)*o.r,Math.sin(o.a)*o.r*.55,6);
    }
  });
  comets.forEach(function(c){
    if(!c.active&&Math.random()<.0016){
      c.active=true;c.t=0;
      c.o={x:(Math.random()-.5)*800,y:150+Math.random()*250,z:-400-Math.random()*400,
        vx:-(2+Math.random()*3),vy:-(1+Math.random()*1.2)};
    }
    if(c.active){
      c.t++;
      var x=c.o.x+c.o.vx*c.t,y=c.o.y+c.o.vy*c.t;
      c.head.position.set(x,y,c.o.z);
      c.head.material.opacity=Math.max(0,1-c.t/100)*.85;
      c.tail.geometry.setFromPoints([new THREE.Vector3(x,y,c.o.z),
        new THREE.Vector3(x-c.o.vx*14,y-c.o.vy*14,c.o.z)]);
      c.tail.material.opacity=c.head.material.opacity*.5;
      if(c.t>110){c.active=false;c.head.material.opacity=0;c.tail.material.opacity=0;}
    }
  });
  renderer.render(scene,camera);
  t++;
}
if(reduced){
  draw();
  addEventListener('scroll',draw,{passive:true});
}else{
  (function loop(){draw();requestAnimationFrame(loop);})();
}
})();
